'use client';

import { useTranslations } from 'next-intl';
import { ClawPassIcon } from '@/app/components/icons/ClawPassIcon';
import { getEffectiveValidTo } from '@/app/components/shared/ClawPassContent/utils';
import { Button } from '@/app/components/ui/button';
import { CLAW_RULES_URL } from '@/app/constants';
import { useStore } from '@/app/providers/store';
import { openOrRedirect } from '@/app/utils/client';
import { useOpenPurchaseDialog } from '../_hook/use-open-purchase-dialog';

export const PayClawPassTooltip = () => {
  const t = useTranslations();
  const openPurchaseDialog = useOpenPurchaseDialog();

  const { clawPass } = useStore((state) => ({
    clawPass: state.clawPass,
  }));

  const effectiveValidTo = getEffectiveValidTo(clawPass);
  const isTrial = clawPass?.userVariant === 'trial';
  // 仅对 trial 判定过期；付费用户的过期/即将过期由 banner（useClawPassExpire）单独处理，
  // 避免与本 tooltip 同时展示导致重复提示。
  const isTrialExpired = isTrial && !!effectiveValidTo && new Date(effectiveValidTo) < new Date();

  const handleUpgrade = () => {
    openPurchaseDialog('push_tab');
  };

  if (!clawPass || !isTrial) {
    return null;
  }

  const messageKey = isTrialExpired ? 'trialExpired' : 'trialExpiring';

  return (
    <div className="px-4 pt-2 sm:p-0">
      <div className="flex h-11 items-center gap-2 rounded-12 border border-system-white08 bg-[rgba(87,101,242,0.32)] pr-1.5 pl-4">
        <div className="flex min-w-0 flex-1 items-center gap-1">
          <ClawPassIcon className="size-4 shrink-0 text-[#939CFF]" />
          <p className="truncate bg-gradient-to-r light:bg-none from-[#B2B9FF] to-white light:bg-clip-border bg-clip-text light:text-[#5765F2] text-transparent text-xs">
            {t.rich(`claw.layoutShell.${messageKey}`, {
              span: (chunks) => (
                <span
                  className="cursor-pointer underline"
                  onClick={() => {
                    openOrRedirect(CLAW_RULES_URL);
                  }}
                >
                  {chunks}
                </span>
              ),
            })}
          </p>
        </div>
        <Button
          onClick={handleUpgrade}
          className="h-7 shrink-0 bg-[#5765F2] light:text-white text-system-white text-xs transition-opacity hover:opacity-90"
        >
          {t('claw.layoutShell.upgrade')}
        </Button>
      </div>
    </div>
  );
};
